import React from 'react';

/**
 * Party Scroll v6 — the featured-rail frame.
 *
 * A card with two offset glitch borders: cyan pulled up-left, magenta pushed
 * down-right, both behind a solid-white content layer. This is the signature
 * "featured" treatment; only Featured cards get it (design rule 1).
 *
 * Offsets are small (4px) to match the mobile rail; pass `offset` to scale
 * up on desktop (design uses 5px there).
 */
export default function GlitchBorderCard({
  children,
  offset = 4,
  className = '',
  /** Classes for the inner content layer — needed to stretch a card to a row. */
  bodyClassName = '',
  /** The black 2px border. The events wall's Featured rail keeps only the glitch pair. */
  bordered = true,
  onClick,
  ...rest
}) {
  return (
    <div
      onClick={onClick}
      className={`relative ${bordered ? 'border-2 border-black' : ''} bg-white ${onClick ? 'cursor-pointer' : ''} ${className}`}
      {...rest}
    >
      {/* cyan border, up-left */}
      <span
        aria-hidden
        className="pointer-events-none absolute inset-0 border-2 border-glitch-cyan"
        style={{ transform: `translate(-${offset}px, -${offset}px)`, zIndex: 0 }}
      />
      {/* magenta border, down-right */}
      <span
        aria-hidden
        className="pointer-events-none absolute inset-0 border-2 border-glitch-magenta"
        style={{ transform: `translate(${offset}px, ${offset}px)`, zIndex: 0 }}
      />
      <div className={`relative bg-white ${bodyClassName}`} style={{ zIndex: 1 }}>
        {children}
      </div>
    </div>
  );
}
